module.exports = __webpack_public_path__ + "img/molisana-mobile.222137c9.png";